import React from 'react'
import {Box, Typography} from '@mui/material'
import {useSelector} from 'react-redux'
import {Button} from '../../button'
import {ButtonBox, Row, UpgradeBox} from './styles'
import {studyGuideURLs} from '../../../constants/studyGuides'
import {Course} from '../../../redux/courses'
import {useAuth} from '../../AuthProvider'
import {selectMember, selectMemberAccess} from '../../../redux/members'
import {useAppDispatch} from '../../../redux/configureStore'
import {handleUpgrade} from '../../../utils/upgradeHelper'

type Props = {
  course: Course
}

const View = ({course}: Props) => {
  const auth = useAuth()
  const dispatch = useAppDispatch()

  const access = useSelector(selectMemberAccess)
  const member = useSelector(selectMember)

  const goToStudyGuide = () => {
    const url = studyGuideURLs[course.abbreviation]
    window.open(url)
  }

  const hasAccess =
    access && Object.keys(access).length !== 0
      ? Number(access.are?.study_guides?.value) === 1
      : false

  return (
    <Box className="ignore" sx={{width: '100% !important'}}>
      <Row>
        <Typography variant={'h3'}>Study Guide</Typography>
        <ButtonBox>
          <Button
            color={'primary'}
            children={'Read'}
            onClick={goToStudyGuide}
            event="file_download"
            disabled={!auth.isAuthenticated || !hasAccess}
          />
          {!hasAccess && (
            <UpgradeBox
              onClick={handleUpgrade(
                dispatch,
                auth,
                member,
                'study guide paywall',
              )}
            >
              Upgrade to Expert
            </UpgradeBox>
          )}
        </ButtonBox>
      </Row>
    </Box>
  )
}

export default View
